export const paths = {
  clinics: () => ['values', 'clinics'],
  counties: () => ['values', 'counties'],
  payers: () => ['values', 'payers'],
  searchResults: (searchType, searchTerm) => ['searchReults', searchType, searchTerm],
}
